import { html } from 'lit';
import { CornerUpLeft } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-corner-up-left')
export class PdsIconCornerUpLeft extends PdsIcon {
  @state()
  icon = CornerUpLeft;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
